// THE university count — the single place the number lives (founder call
// 2026-07-26: "I shouldn't have to change it everywhere when it grows").
//
// Every user-visible mention of how many universities Stratia covers imports
// this. When the catalog grows, change THIS LINE and the whole app follows;
// a guard test (catalogCountGuard.test.js) fails the build if a literal count
// sneaks back into copy anywhere else.
//
// History: on 2026-07-26 the product was saying "215+" on eleven surfaces and
// "217" on six at the same time. Exact beats hedged ("217" reads as counted,
// "215+" reads as marketing), but exact only stays honest if it is ONE value.
//
// index.html USED to be a hand-maintained surface, and drifted for nine days
// (the page head still said 200+ universities / 10,000+ decisions, which is
// what Google indexed). It now carries {{UNIVERSITY_COUNT}}-style placeholders
// that vite.config.js substitutes at build time from THIS file; an unknown or
// unresolved placeholder fails the build.
//
// Surfaces that CANNOT import this and must be updated by hand on change:
//   - Google Ads console copy (marketing/google-ads-setup.md — headline
//     "Free Odds at 217 Colleges" and callout "217 universities")
//   - marketing/*.md collateral and LinkedIn post templates
//   - rendered demo videos (captions are burned in; the journey scripts under
//     marketing/videos/tooling/journeys/ carry the number — re-render after
//     bumping)
//   - Python email scripts (scripts/send_journey_nudge_drafts.py)
//   - resource-paper INFOGRAPHIC images (regenerated, not live)
export const UNIVERSITY_COUNT = 248;

// The other two headline stats, same single-source rule. These grow
// continuously (every collection run, every outcomes sweep), so they are
// deliberately HEDGED floors rather than exact counts — bump when the live
// number clears the next round threshold. Live truth on 2026-09-08 (computed
// straight from Firestore): 24,110 decision records across 177 schools (712
// class-year documents); 7,502 distinct majors (22,349 per-school listings),
// which does NOT clear 8,000, so that label stays where it is.
//
// Recompute the decisions from the SUBCOLLECTIONS, never the summary field.
// The top-level `reported_outcomes_summary.total_records` (top-level, NOT
// under profile) is STALE, not empty: it reads 14,027 across 130 schools
// while universities/*/reported_outcomes/<class year> holds 24,110 across
// 177. Stale-but-plausible is the dangerous kind — it will not look wrong.
// Majors: distinct names across profile.academic_structure.colleges[].majors[].
export const DECISION_POINTS_LABEL = '24,000+';

// Majors mapped into a related-fields family — what powers the alternate-door
// suggestions. Same hedged-floor rule. Live truth 2026-09-08: 4,854 of the
// 5,564 normalized major keys carry a family (710 unclassified) across 15
// families. It sat hard-coded as '3,000+' on both landing pages with no
// constant behind it, so it never moved as the catalog grew. Recompute:
// build_adjacency() in
// cloud_functions/knowledge_base_manager_universities_v2/major_adjacency.py
// over every university profile — len(adj['majors']) - len(adj['unclassified']).
// NOTE: the map production SERVES (major_adjacency/current) has drifted from
// what a rebuild produces — 7,206 keys / 6,443 mapped / university_count 211
// against a 248-school KB, because add_school_adjacency() never prunes (#2084).
// '4,000+' is a true floor under both readings; when #2084 lands, point this
// recipe at whichever source is authoritative.
export const FAMILY_MAPPED_LABEL = '4,000+';
export const MAJORS_LABEL = '7,000+';

// The major-door figures, same single-source rule. These are EXACT and
// deliberately smaller than they could be made to look: `is_impacted` is a
// field present on every major listing (22,347 on 2026-10-11), but a real
// restriction is recorded on 1,475 of them across 84 schools. Having the
// field is not having the answer, and this page's whole claim is that we
// know the door — so the number we publish is the one we can defend.
//
// Majors the KB lists under two colleges (UT Austin's CS, six at Michigan
// Tech) are deduped per school at generation, because a count that
// double-counts is the same class of error as a count that is invented.
//
// DERIVED, never typed (#3818: these said 1,054 / 69 for a month while the
// KB grew to 1,475 / 84). Regenerate the dataset AND these two lines with:
//   python3 scripts/generate_major_doors.py
// MajorDoorsPage.test.jsx pins both to frontend/src/data/majorDoors.json.
// The verified summer-programs catalog, same single-source rule. EXACT:
// counted from cloud_functions/counselor_agent/summer_programs.json (the
// tests pin every entry's provenance). Grew 89 -> 269 on 2026-08-22 via the
// capture pipeline in agents/summer_programs/; 261 since the 2026-10-28
// re-read (#5694) removed 8 no longer open to high school students or not
// running in summer 2027. catalogCountGuard.test.js pins it to the JSON.
export const SUMMER_PROGRAM_COUNT = 261;

// CAMPUS_FEED_COUNT (the scraped campus-events collection's weekly-swept
// school count) retired 2026-09-03 with the campus-events sweep pipeline
// itself — Book the Visit links every one of UNIVERSITY_COUNT schools to
// their own visit page directly, so the marketing claim is the same
// number as the university count, not a scraped subset.

export const GATED_MAJORS = 1475;
export const GATED_MAJOR_SCHOOLS = 84;
